import { useMutation, useQueryClient } from 'react-query'

import { mediaService } from 'src/services'
import { unSdgService } from 'src/services/un-sdg.service'
import { IUnSdgUpdateForm } from 'src/types'

import { QUERY_KEYS } from 'src/constants'

const useUpdateUnSdg = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async ({ oldIcon, image, ...sdg }: IUnSdgUpdateForm) => {
      oldIcon && image.file && (await mediaService.removeFileWithCompression(oldIcon))

      const uploadedFile = image.file
        ? await mediaService.uploadFileWithCompression(image.file)
        : null

      return unSdgService.updateUnSdg({
        ...sdg,
        image: uploadedFile ? uploadedFile.link : oldIcon,
        image_small: uploadedFile ? String(uploadedFile.link_small) : sdg.image_small,
        image_medium: uploadedFile ? String(uploadedFile.link_medium) : sdg.image_medium,
      })
    },
    {
      onSuccess: (data) => {
        if (data) {
          queryClient.invalidateQueries(QUERY_KEYS.UN_SDGS)
        }
      },
    },
  )
}

export { useUpdateUnSdg }
